import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import es from "./locales/es.json";

// Get saved language from localStorage or use default (restricted to en/es)
const rawSavedLang = localStorage.getItem("i18nLang");
const savedLang = rawSavedLang === "es" || rawSavedLang === "en" ? rawSavedLang : "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
  },
  lng: savedLang,
  fallbackLng: "en",
  supportedLngs: ["en", "es"],

  interpolation: {
    escapeValue: false,
  },
});

// Persist language to localStorage on every change
i18n.on("languageChanged", (lang) => {
  const safeLang = lang === "es" ? "es" : "en";
  localStorage.setItem("i18nLang", safeLang);
});

export default i18n;
